
import { defineComponent, ref } from 'vue';
import Dialog from 'primevue/dialog';
import SpmButton from '@/components/spm-primevue/SpmButton.vue';
import type { ActionPayload, DeleteActionResult } from './types';

export default defineComponent({
  name: 'DeleteAction',

  components: {
    Dialog,
    SpmButton,
  },

  props: {
    /**
     * Dialog title
     */
    dialogTitle: {
      type: String,
      default: '',
    },

    /**
     * Confirmation message
     */
    message: {
      type: String,
      default: '',
    },

    /**
     * Cancel button label
     */
    cancelLabel: {
      type: String,
      default: '',
    },

    /**
     * Confirm button label
     */
    confirmLabel: {
      type: String,
      default: '',
    },
  },

  emits: ['confirm'],

  setup(props, { emit, expose }) {
    // Internal state
    const isVisible = ref(false);
    const currentPayload = ref<ActionPayload | null>(null);

    /**
     * Open the dialog with the given payload
     */
    const open = (payload: ActionPayload) => {
      currentPayload.value = payload;
      isVisible.value = true;
    };

    /**
     * Close the dialog
     */
    const close = () => {
      isVisible.value = false;
      currentPayload.value = null;
    };

    /**
     * Confirm the action and emit result
     */
    const confirm = () => {
      if (!currentPayload.value) return;

      const result: DeleteActionResult = {
        id: currentPayload.value.id,
        name: currentPayload.value.name,
      };

      emit('confirm', result);
      close();
    };

    // Expose open method for parent component
    expose({ open });

    return {
      isVisible,
      currentPayload,
      close,
      confirm,
    };
  },
});
